<template>
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ transform: `rotate(${rotate})` }"
  >
    <path
      d="M1 0.999999L7 7L13 1"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#e58413',
    },
    rotate: {
      type: String,
      default: '0',
    },
  },
};
</script>

<style lang="scss" scoped></style>
